import React, { useState, useEffect, useRef, useContext } from "react";
import { useLocation } from "react-router-dom";
import CustomInput from "../../components/CustomInput";
import { useTranslation } from "react-i18next";
import BackToDashboard from "../../components/BackToDashboard";
import useLanguage from "../../utils/useLanguage";
import ErrorBox from "../../components/ErrorBox";
import Modal from "../../components/Modal";
import CustomButton from "../../components/CustomButton";
import classes from "./CustomersPage.module.css";
import classes1 from "../../components/PDFUploader.module.css";
import saveIcon from "../../assets/save_icon.png";
import closeIcon from "../../assets/close_icon.png";
import previousIcon from "../../assets/previous_icon.png";
import nextIcon from "../../assets/next_icon.png";
import Loader from "../../components/Loader";
import uploadIcon from "../../assets/upload_icon.png";
import addIcon from "../../assets/add_icon.png";
import axios from "axios";
import { DataContext } from "../../utils/DataContext";
import PDFUploader from "../../components/PDFUploader";
import ErrorMessage from "../../components/ErrorMessage";
import InformationBox from "../../components/InformationBox";
import imageSliders from "../../components/PDFSlider.module.css";
import PageWrapper from "../../components/PageWrapper";

const MessagePage = () => {
  const { data } = useContext(DataContext);
  const location = useLocation();
  const { t } = useTranslation("general");
  const { selectedCustomers, filteredCustomers } = location.state || {};
  const { currentDirection } = useLanguage();
  const [notes, setNotes] = useState("");
  const [error, setError] = useState("");

  // image state
  const [imageFile, setImageFile] = useState(null);
  const imageInputRef = useRef(null);

  // image functions
  const handleImageUploadClick = () => {
    if (imageInputRef.current) {
      imageInputRef.current.click();
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setImageFile(file);
    } else {
      setImageFile(null);
    }
    e.target.value = null;
  };

  const removeImage = () => {
    setImageFile(null);
  };

  const sendMessage = async () => {
    const payload = new FormData();

    const token = localStorage.getItem("token");
    const userId = parseInt(localStorage.getItem("userId"), 10);
    if (imageFile) {
      payload.append("image", imageFile);
    }

    payload.append(
      "customers",
      JSON.stringify(
        selectedCustomers.map((customer) => ({
          customerName: customer?.data?.name || customer.name,
          customerPhoneNumber:
            customer?.data?.phoneNumber || customer.phoneNumber,
        }))
      )
    );

    payload.append("textMessage", notes);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/sendWhatsAppMessage`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "User-Id": userId,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Upload successful", response.data);
    } catch (err) {
      console.error("Upload failed", err);
    }
  };

  //////

  const [loadingModal, setLoadingModal] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const openModal = () => {
    setShowModal(!showModal);
  };

  const handleCloseModal = () => {
    openModal();
  };

  const handleSubmit = () => {
    if (notes.trim() === "" && imageFile === null) {
      setError(t("emptyFields"));
      return;
    }
    sendMessage();

    setError("");
    handleCloseModal();
  };

  if (
    !selectedCustomers ||
    !filteredCustomers ||
    !Array.isArray(filteredCustomers)
  ) {
    return (
      <div>
        <InformationBox>
          {" "}
          No data received. Please go back and check the data being passed.
        </InformationBox>
      </div>
    );
  }

  return (
    <PageWrapper>
      <div className="e-container">
        <PageWrapper
            style={{ direction: currentDirection }}
            title={t("organizations")}
            withBackButton
        >
          <div>
            <BackToDashboard
              title={t("back")}
              variant="blank-fit-content"
              icon={currentDirection === "ltr" ? previousIcon : nextIcon}
              iconSize={14}
            />
          </div>
          {error && (
            <div className={classes.errorBox}>
              <ErrorBox>{error}</ErrorBox>
            </div>
          )}
          <ul className={`${classes.ulStyle} u-styled-scrollbar`}>
            {selectedCustomers.map((customer, index) => (
              <li key={index} className={classes.namesStyle}>
                {customer?.data?.name || customer.name}
              </li>
            ))}
          </ul>

          <div className={classes.layoutMsg}>
            <label>{t("titleMessage")}</label>
            <ErrorMessage>{error}</ErrorMessage>
            <CustomInput
              name="notes"
              type="textarea"
              placeholder={t("msg")}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
            <div className={classes.layoutBtns}>
              <CustomButton
                title={t("uploadImage")}
                icon={uploadIcon}
                iconSize={16}
                onClick={handleImageUploadClick}
              />
              <input
                type="file"
                accept="image/*"
                ref={imageInputRef}
                onChange={handleImageChange}
                style={{ display: "none" }}
              />
            </div>
            {imageFile && (
              <div className={imageSliders.sliderImage}>
                <div className="editMainDiv">
                  <a
                    href={URL.createObjectURL(imageFile)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={URL.createObjectURL(imageFile)}
                      alt={imageFile.name}
                      className={imageSliders.image}
                    />
                  </a>
                  <div onClick={removeImage} className="">
                    ✕
                  </div>
                </div>
              </div>
            )}

            {showModal && (
              <Modal
                title={t("contactCustomer")}
                onClose={handleCloseModal}
                footer={
                  <>
                    {loadingModal ? <Loader /> : null}
                    <section
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "5px",
                      }}
                    >
                      <CustomButton
                        title={t("cancel")}
                        onClick={handleCloseModal}
                        variant="blank"
                        icon={closeIcon}
                        iconSize={14}
                      />
                      <CustomButton
                        title={t("confirm")}
                        icon={saveIcon}
                        iconSize={16}
                        onClick={() => {
                          handleSubmit();
                        }}
                        disabled={loadingModal}
                      />
                    </section>
                  </>
                }
              >
                <div>
                  <h3 style={{ textAlign: "center" }}>{t("sureMsg")}</h3>
                </div>
              </Modal>
            )}
          </div>
          <div className="o-row o-row--horizontal-align_center u-margin--bottom_700">
            <CustomButton
              title={t("send")}
              iconSize={18}
              onClick={openModal}
              style={{ width: "100%" }}
            />
          </div>
        </PageWrapper>
      </div>
    </PageWrapper>
  );
};

export default MessagePage;
